export function Redirect() {
  window.location.replace(
    'https://www.theknot.com/us/robert-chatterton-and-loren-genrich-sep-2025',
  );
  return null;
}
